import { z } from 'zod';
import { ExareStatus } from '@websky/graphql';
import { CardType } from '../PromoLoader/types';
import { PromoMessageIcons } from '../PromoMessage/types';
import { BooleanOptional, NumberOptional, StringOptional } from './schemaTypes';
import { Sorting } from '../Results/enums';
import { CheckoutSteps } from '../MobileStepbar/types';
import { CheckinStep } from '../Modules/Checkin/types';
const RefundSuccessModalStatusesSchema = z.record(z.nativeEnum(ExareStatus), z.boolean()).optional();
const RefundSchema = z
    .object({
    successModal: z
        .object({
        create: RefundSuccessModalStatusesSchema,
        request: RefundSuccessModalStatusesSchema
    })
        .optional()
})
    .optional();
export const StepSchema = z.object({
    isHidden: z.boolean().optional(),
    isDisabled: z.boolean().optional(),
    label: z.string(),
    type: z.union([z.nativeEnum(CheckoutSteps), z.nativeEnum(CheckinStep)]).optional(),
    alwaysActive: z.boolean().optional(),
    alwaysOpen: z.boolean().optional(),
    onClick: z.function().args().returns(z.void()).optional()
});
export const StepsSchema = z.record(StepSchema);
const CardSchema = z.object({
    city: StringOptional,
    type: z.nativeEnum(CardType).nullish(),
    title: StringOptional,
    text: StringOptional,
    image: z.string()
});
const PromoMessageLinkSchema = z.object({
    text: z.string(),
    url: z.string().url()
});
export const PromoMessageSchema = z.object({
    title: z.string(),
    content: z.string(),
    icon: z.nativeEnum(PromoMessageIcons).optional(),
    link: PromoMessageLinkSchema.optional()
});
export const EngineSchema = z.object({
    defaultSteps: StepsSchema.optional(),
    searchFormURL: StringOptional,
    promoLoaders: z.array(CardSchema).optional(),
    simpleLoaders: z.array(CardSchema).optional(),
    promoMessages: z.array(PromoMessageSchema).optional(),
    checkInEnabled: BooleanOptional,
    checkInURL: StringOptional,
    showRefundRedirectButton: BooleanOptional,
    mealWarning: StringOptional,
    mealDefaultFilterButtonPlacement: z.enum(['start', 'end']).optional(),
    calendarDaysCount: NumberOptional,
    showAvailableFaresOnly: BooleanOptional,
    showTicketRefundOptionModal: BooleanOptional,
    accountURL: StringOptional,
    nasServiceUpsaleForConfirmedOrder: BooleanOptional,
    sortResultPreferCurrentAirline: BooleanOptional,
    resultsFareSelectorInModal: BooleanOptional,
    ignoreBlockedPaymentToReturnOrder: BooleanOptional,
    googleOneTapSignInClientId: StringOptional,
    exareShowPassengersStep: BooleanOptional,
    checkFfpStatus: BooleanOptional,
    resultsDefaultSorting: z.nativeEnum(Sorting).optional(),
    nas: z.optional(z.object({
        suggestServicesTypes: z.array(z.string()),
        suggestedServicesOrder: z.record(z.number())
    })),
    RTMinPricesForOWFlights: BooleanOptional,
    useActualizedOrderFlightPrices: BooleanOptional,
    refund: RefundSchema
});
